import Link from 'next/link'
import React from 'react'

const SliderSectionTop = ({ title, linkText }) => {
    return (
        <>
            <h3 className='news-details__section-title'>{title}</h3>
            <Link
                href='/useful-materials'
                className='useful-materials__link'
            >
                <p>{linkText}</p>
                <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                >
                    <path
                        d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                        stroke='#919EBF'
                        strokeWidth='2'
                        strokeLinecap='round'
                    />
                </svg>
            </Link>
        </>
    )
}

export default SliderSectionTop
